import { Component } from '@angular/core';
import { BaseMenuComponent } from './base.menu';
import { ModalComponent } from '../modal/modal.component';

@Component({
    templateUrl: './action-plan.menu.html',
    standalone: false
})
export class ActionPlanMenuComponent extends BaseMenuComponent {
  public menus: any = ActionPlanDetailMenu;

  constructor(public modal: ModalComponent) {
    super(modal);
  }
}

export enum ActionPlanDetailMenu {
  Done = 1,
  Collaborate = 2,
  CreateReport = 3,
  Reports = 4,
  Inspection = 5,
  ChangeInputLanguage = 6
}
